/**
 * @deprecated Use Switch from ui/forms/Switch instead
 */
import cx from "ui/cx";
import styles from "./Toggle.module.scss";

interface ToggleProps {
  isTrue: boolean;
  onChange: (isTrue: boolean) => void;
  disabled?: boolean;
  variants?: "medium" | "small" | "x-small";
  id?: string;
  ariaLabel?: string;
  dataTestId?: string;
}

export default function Toggle({
  id,
  ariaLabel,
  isTrue,
  onChange,
  disabled = false,
  variants = "medium",
  dataTestId,
}: ToggleProps) {
  const classNames = cx({
    styles,
    wrapper: true,
    disabled,
    small: variants === "small",
    xsmall: variants === "x-small",
  });

  return (
    <div className={classNames} onClick={(e) => e.stopPropagation()}>
      <label className="toggle" data-testid={dataTestId}>
        <input
          aria-label={ariaLabel}
          type="checkbox"
          checked={isTrue}
          onChange={(e) => onChange(e.currentTarget.checked)}
          disabled={disabled}
          id={id}
        />
        <i></i>
      </label>
    </div>
  );
}
